import { Outlet } from 'react-router-dom';

function Mora() {
  return <Outlet />;
}

export default Mora;
